import React, { useEffect, useState, useRef } from 'react'
import { useParams, useNavigate } from 'react-router'
import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/outline'
import { api } from '../utils/api'

const VerifyEmailChange = () => {
  const { token } = useParams()
  const navigate = useNavigate()
  const [status, setStatus] = useState('verifying') // 'verifying', 'success', 'error'
  const [message, setMessage] = useState('')
  const [newEmail, setNewEmail] = useState('')
  const hasVerified = useRef(false)

  useEffect(() => {
    const verifyEmail = async () => {
      // Prevent double execution in React Strict Mode
      if (hasVerified.current) {
        return
      }
      hasVerified.current = true

      if (!token) {
        setStatus('error')
        setMessage('Ongeldige verificatielink')
        return
      }

      try {
        const response = await api.get(`/users/verify-email-change/${token}`)
        setStatus('success')
        setMessage(response.data.message)
        setNewEmail(response.data.email)

        // Redirect to dashboard after 3 seconds
        setTimeout(() => {
          navigate('/dashboard')
        }, 3000)
      } catch (error) {
        setStatus('error')
        setMessage(error.response?.data?.error || 'Er is een fout opgetreden bij het verifiëren van je e-mailadres')
      }
    }

    verifyEmail()
  }, [token, navigate])

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8">
          {status === 'verifying' && (
            <div className="text-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4"></div>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
                E-mailadres verifiëren...
              </h2>
              <p className="text-gray-600 dark:text-gray-400">
                Een moment geduld
              </p>
            </div>
          )}

          {status === 'success' && (
            <div className="text-center">
              <CheckCircleIcon className="h-16 w-16 text-green-600 dark:text-green-400 mx-auto mb-4" />
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
                E-mailadres succesvol gewijzigd!
              </h2>
              <p className="text-gray-600 dark:text-gray-400 mb-4">
                {message}
              </p>
              {newEmail && (
                <div className="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg p-4 mb-4">
                  <p className="text-sm text-gray-700 dark:text-gray-300">
                    Je nieuwe e-mailadres:
                  </p>
                  <p className="text-lg font-semibold text-gray-900 dark:text-white">
                    {newEmail}
                  </p>
                </div>
              )}
              <p className="text-sm text-gray-500 dark:text-gray-400">
                Je wordt doorgestuurd naar je dashboard...
              </p>
            </div>
          )}

          {status === 'error' && (
            <div className="text-center">
              <XCircleIcon className="h-16 w-16 text-red-600 dark:text-red-400 mx-auto mb-4" />
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
                Verificatie mislukt
              </h2>
              <p className="text-gray-600 dark:text-gray-400 mb-6">
                {message}
              </p>
              <button
                onClick={() => navigate('/dashboard')}
                className="px-6 py-2 bg-primary-600 hover:bg-primary-700 text-white rounded-lg transition-colors"
              >
                Terug naar dashboard
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default VerifyEmailChange
